module.exports = __webpack_public_path__ + "img/b1.f85ec83d.jpg";